import { useEffect, useState } from "react";
import SC from "./style";
import { AccessDeniedMessage, Loader } from "@InnoUI/";
import { apiPost } from "api/callApi";
import { useSearchParams } from "react-router-dom";
import { userAccessType } from "utils/lookUpTable";
import { ConfigProvider, Spin } from "antd";
import { useSelector } from "react-redux";

const CheckPermissionWrapper = ({ children, notLoad = false }) => {
  const [permission, setPermission] = useState(2);
  const [loading, setLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const folderId = searchParams.get("folderId");
  const routeProjectId = searchParams.get("projectId");
  const type = searchParams.get("type");
  const currentProject = useSelector(
    (state) => state.currentProject.data || null
  );

  useEffect(() => {
    const fetchPermissions = async () => {
      if (!folderId) {
        setPermission(userAccessType.write);
        setLoading(false);
        return;
      }

      const permissionProjectId =
        currentProject?.id || (type !== "1" ? routeProjectId : null);

      if (!permissionProjectId) {
        setLoading(true);
        return;
      }

      try {
        setLoading(true);
        const response = await apiPost(`/v1/options/checkpermissions`, {
          folderId: folderId,
          projectId: permissionProjectId,
        });
        setPermission(response.permissionType);
      } catch (error) {
        console.error("Error fetching permissions:", error);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    fetchPermissions();
  }, [currentProject?.id, folderId, routeProjectId, type]);

  if (loading && !notLoad)
    return (
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: "orange",
          },
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            position: "absolute",
            width: "80%",
            height: "70vh",
            zIndex: 2000,
          }}
        >
          <div>
            <Spin size="large" />
          </div>
        </div>
      </ConfigProvider>
    );

  // Show Access Denied Message if user has no access
  if (permission === userAccessType.none) {
    return (
      <>
        <div>
          <AccessDeniedMessage />
        </div>
      </>
    );
  }

  return typeof children === "function" ? children({ permission }) : children;
};

export default CheckPermissionWrapper;
